// extracted by mini-css-extract-plugin
export var quantityInput = "_kc-0";